export default __webpack_public_path__ + "static/media/Icon-awesome-eye.36042cb8.svg";